import { Link, Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { ContributingEntityStatus } from "../../../../../autogen/bff-api";

const COLOR_SCHEME: Record<ContributingEntityStatus, string> = {
  [ContributingEntityStatus.NotSent]: "gray",
  [ContributingEntityStatus.InvitationSent]: "blue",
  [ContributingEntityStatus.InvitationAccepted]: "blue",
  [ContributingEntityStatus.InvitationDeclined]: "red",
  [ContributingEntityStatus.ResponseSubmitted]: "orange",
  [ContributingEntityStatus.ResponseNotApproved]: "orange",
  [ContributingEntityStatus.ResponseValidated]: "green",
};

const ANSWERED_STATUSES: ReadonlySet<ContributingEntityStatus> = new Set([
  ContributingEntityStatus.ResponseSubmitted,
  ContributingEntityStatus.ResponseNotApproved,
  ContributingEntityStatus.ResponseValidated,
]);

export const hasSubmittedAnswer = (status: ContributingEntityStatus): boolean =>
  ANSWERED_STATUSES.has(status);

export const ContributingEntityStatusTag = ({
  status,
  to,
}: {
  status: ContributingEntityStatus;
  to?: string;
}) => {
  const { t } = useTranslation();
  const tag = (
    <Tag size="sm" colorScheme={COLOR_SCHEME[status]} whiteSpace="nowrap">
      {t(status)}
    </Tag>
  );

  if (!to) return tag;

  // A bare anchor is display:inline, so its line box nudges the tag off centre next to a button.
  return (
    <Link
      as={RouterLink}
      to={to}
      display="inline-flex"
      alignItems="center"
      aria-label={`${t(status)} – ${t("See the answer")}`}
    >
      {tag}
    </Link>
  );
};
